/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AssignmentTemplate } from './AssignmentTemplate';
import { FileTree } from './FileTree';
const ExtendedAssignmentTemplateParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['files', /* #__PURE__ */ parsers.maybeNull(FileTree)],
]), AssignmentTemplate);
export class ExtendedAssignmentTemplate extends AssignmentTemplate {
    static decode(input) {
        return ExtendedAssignmentTemplateParser.decode(input).map(res => new ExtendedAssignmentTemplate(res));
    }
    static unsafeDecode(input) {
        return ExtendedAssignmentTemplate.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedAssignmentTemplateParser.encode(data);
    }
    static schema() {
        return ExtendedAssignmentTemplateParser.schema();
    }
}
